<template>
  <BaseDrawer
    :is-open="isOpen"
    shrink
    @close="emit('close')"
  >
    <DrawerHeader @close="emit('close')">
      Enter email address
    </DrawerHeader>
    <form
      class="flex flex-1 flex-col space-y-6 p-4"
      novalidate
      @submit="onSubmit"
    >
      <div
        class="text-center text-sm text-background-fg/50"
      >
        A link to our customer portal will be sent to the
        requested address.
      </div>
      <TextInputFormField name="email" type="email" />
      <ActionButtonPrimary
        type="submit"
        :is-loading="isSubmitting"
        >Send access link</ActionButtonPrimary
      >
    </form>
  </BaseDrawer>
</template>

<script setup lang="ts">
import { sendBusinessFundingComms } from "@/services/sendBusinessFundingComms"
import { toTypedSchema } from "@vee-validate/zod"
import { useForm } from "vee-validate"
import z from "zod"
import { emailAddressSchema } from "@/forms/validation/stringFieldSchemas"

defineProps<{ isOpen: boolean }>()

const emit = defineEmits<{ (event: "close"): void }>()

const formSchema = z.object({
  email: emailAddressSchema("Email is required"),
})

const { handleSubmit, isSubmitting } = useForm({
  validationSchema: toTypedSchema(formSchema),
  initialValues: {
    email: "",
  },
})

const onSubmit = handleSubmit(async (formValues) => {
  try {
    await sendBusinessFundingComms(formValues)
    toast.success(`Email sent to ${formValues.email}`)
    emit("close")
  } catch {
    toast.error("Failed to send email")
  }
})
</script>
